import { render, staticRenderFns } from "./NewCompanyWizard.vue?vue&type=template&id=52ecbe9a&scoped=true&"
import script from "./NewCompanyWizard.vue?vue&type=script&lang=js&"
export * from "./NewCompanyWizard.vue?vue&type=script&lang=js&"
import style0 from "./NewCompanyWizard.vue?vue&type=style&index=0&id=52ecbe9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecbe9a",
  null
  
)

export default component.exports